export default __webpack_public_path__ + "static/media/loading_trasnparent.1633ecaa.gif";